import { useCallback } from 'react';
import {
  type NavigationProp,
  type RouteProp,
  useNavigation,
  useRoute,
} from '@react-navigation/native';

import { useContactUsHandler } from '../../../../hooks';
import { type HomeTabStackParamList } from '../../../../navigation/AppNavigation.props';

export const useOpenChatFromHomeScreen = () => {
  const { params } = useRoute<Route>();
  const { setParams } = useNavigation<Navigation>();
  const { handleContactUs } = useContactUsHandler('home');

  return useCallback(() => {
    if (!params?.chat) return;

    setParams({ chat: false });
    void handleContactUs();
  }, [params?.chat, setParams, handleContactUs]);
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Route = RouteProp<HomeTabStackParamList, 'Home'>;
type Navigation = NavigationProp<HomeTabStackParamList, 'Home'>;
